const axios = require('axios')

export default {

  queryMakerGptAPI: async function (path, data, _headers) {
    try {
      // const apiUrl = user.gtpUrl;
      const apiUrl = 'https://gptapi.botboom.ru'
      const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjMwNDcxMDM2NSIsImlhdCI6MTczMzkzMzk3Mn0.aMY-NFN-xdCSyAgxmtrvqmiKwwRduN4eQ-_7xA4vZWg'
      const headers = {
        Authorization: `Bearer ${token}`,
        ..._headers
      }
      if (!(data instanceof FormData)) {
        headers['Content-Type'] = 'application/json'
      }
      const _reply = await axios.post(`${apiUrl}${path}`, data, { headers, timeout: 180000 })
      if (!_reply.data) throw new Error('api error')
      return _reply.data
    } catch (err) {
      console.log(err.message || 'ошибка апи')
      return { err: true, message: err.message || 'ошибка апи' }
    }
  },

  getOaiProxyTask: async function ({ baseUrl, taskId, commonKey }) {
    const url = `${baseUrl}/proxy/responses/tasks/${encodeURIComponent(String(taskId || ''))}`
    const headers = {
      'Content-Type': 'application/json',
      ...(commonKey ? { commonKey } : {})
    }
    const _reply = await axios.get(url, { headers, timeout: 180000 })
    if (!_reply.data) throw new Error('api error')
    return _reply.data
  },

  generateImageViaOaiProxy: async function ({ commonKey, input, model = 'gpt-5.4', async = true }) {
    try {
      // const baseUrl = 'https://oaiproxy.botboom.ru:3001'
      const baseUrl = 'https://api.maker-gpt.pro'
      const url = `${baseUrl}/proxy/responses`
      const headers = {
        'Content-Type': 'application/json',
        ...(commonKey ? { commonKey } : {})
      }
      const payload = {
        model,
        input,
        tools: [{ type: 'image_generation' }],
        async: Boolean(async)
      }
      const _reply = await axios.post(url, payload, { headers, timeout: 180000 })
      if (!_reply.data) throw new Error('api error')

      // async mode: 202 { taskId, status } → poll GET /proxy/responses/tasks/:taskId
      if (payload.async) {
        const taskId = _reply.data.taskId || _reply.data.task_id
        if (!taskId) throw new Error('Task id not found')

        const startedAt = Date.now()
        const maxWaitMs = 6 * 60 * 1000 // 6 minutes
        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (Date.now() - startedAt > maxWaitMs) throw new Error('Timeout while waiting for image generation')
          const task = await this.getOaiProxyTask({ baseUrl, taskId, commonKey })
          if (task?.status === 'succeeded') return task.response
          if (task?.status === 'failed') {
            const msg = task?.error?.message || 'Task failed'
            throw new Error(msg)
          }
          await new Promise(resolve => setTimeout(resolve, 1000))
        }
      }

      return _reply.data
    } catch (err) {
      console.log(err.message || 'ошибка апи')
      return { err: true, message: err.message || 'ошибка апи' }
    }
  },

  queryMakerGptAPI_async: async function (path, data, _headers) {
    try {
      // const apiUrl = user.gtpUrl;
      const apiUrl = 'https://gptapi.botboom.ru'
      const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjMwNDcxMDM2NSIsImlhdCI6MTczMzkzMzk3Mn0.aMY-NFN-xdCSyAgxmtrvqmiKwwRduN4eQ-_7xA4vZWg'
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ..._headers
      }
      // const _reply = await axios.post(`${apiUrl}${path}`, data, { headers, timeout: 180000 })
      const _reply = await axios.post(`${apiUrl}${path}`, data, {
        headers,
        timeout: 180000
      })
      const taskId = _reply.data.task_id
      // Опрашиваем до завершения
      let task
      do {
        const res = await axios.get(`${apiUrl}/v1/chat/completions/task/${taskId}`, { headers })
        task = res.data

        if (task.status === 'completed') {
          // console.log('✅ Result:', task.result)
          break
        } else if (task.status === 'failed') {
          throw new Error(`Task failed: ${task.error}`)
        }

        await new Promise(resolve => setTimeout(resolve, 1000))
      } while (task.status === 'pending')
      if (!task.status) throw new Error('api error')
      return task.result
    } catch (err) {
      console.log(err.message || 'ошибка апи')
      return { err: true, message: err.message || 'ошибка апи' }
    }
  },

  queryMakerGptAPI_GET: async function (path, data, _headers) {
    try {
      // const apiUrl = user.gtpUrl;
      const apiUrl = 'https://gptapi.botboom.ru'
      const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjMwNDcxMDM2NSIsImlhdCI6MTczMzkzMzk3Mn0.aMY-NFN-xdCSyAgxmtrvqmiKwwRduN4eQ-_7xA4vZWg'
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ..._headers
      }
      const _reply = await axios.get(`${apiUrl}${path}`, { headers })
      if (!_reply.data) throw new Error('api error')
      return _reply.data
    } catch (err) {
      console.log(err.message || 'ошибка апи')
      return { err: true, message: err.message || 'ошибка апи' }
    }
  },

  queryWeaviateAPI: async function (path, data, _headers) {
    try {
      // const apiUrl = user.gtpUrl;
      // const apiUrl = 'http://10.1.2.116:3005'
      const apiUrl = 'https://gptapi.botboom.ru/db'
      const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjMwNDcxMDM2NSIsImlhdCI6MTcyNDc0NzYwM30.vN18v2Ig1wNFXH4aSNQ_qeNNfZTgoO5xR4T2ZmSrfNk'
      const headers = {
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        ..._headers
      }
      const _reply = await axios.post(`${apiUrl}${path}`, data, { headers })
      if (!_reply.data) throw new Error('api error')
      return _reply.data
    } catch (err) {
      console.log(err.message || 'ошибка Weaviate апи')
      return { err: true, message: err.message || 'ошибка Weaviate апи' }
    }
  }

}
